// extracted by mini-css-extract-plugin
export default {"Day":"Day_Day__8AaBs"};